// 排序 0正序 1 倒叙
export function compare (prop, orderBy) {
  return function (obj1, obj2) {
    const val1 = obj1[prop]
    const val2 = obj2[prop]
    if (val1 < val2) {
      return !orderBy ? -1 : 1
    } else if (val1 > val2) {
      return !orderBy ? 1 : -1
    } else {
      return 0
    }
  }
}

export function showAlarmInfo ({warning, alarm, peccancy, isFilter, hasIndex}) {
  const content = {warning: [], alarm: [], peccancy: []}
  // 报警信息
  const alarmCode = {
    0: '左转-防碰撞',
    1: '右转-防碰撞',
    2: '幅度出-防碰撞',
    3: '幅度进-防碰撞',
    4: '左转-限制区',
    5: '右转-限制区',
    6: '幅度出-限制区',
    7: '幅度进-限制区',
    8: '回转左限位',
    9: '回转右限位',
    10: '幅度出限位',
    11: '幅度进限位',
    12: '高度上限位',
    13: '高度下限位',
    14: '力',
    15: '力矩',
    16: '风速'
  }
  const array = [1, 2, 4, 8, 16, 32, 64, 128, 256, 512, 1024, 2048, 4096, 8192, 16384, 32768, 65536]
  if (isFilter) {
    array.forEach((item, index) => {
      if (peccancy & item) {
        content.peccancy.push(!hasIndex ? alarmCode[index] : index)
      } else if (alarm & item) {
        content.alarm.push(!hasIndex ? alarmCode[index] : index)
      } else if (warning & item) {
        content.warning.push(!hasIndex ? alarmCode[index] : index)
      }
    })
  } else {
    array.forEach((item, index) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions,no-unused-expressions
      warning & item ? content.warning.push(!hasIndex ? alarmCode[index] : index) : ''
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions,no-unused-expressions
      alarm & item ? content.alarm.push(!hasIndex ? alarmCode[index] : index) : ''
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions,no-unused-expressions
      peccancy & item ? content.peccancy.push(!hasIndex ? alarmCode[index] : index) : ''
    })
  }
  return content
}

// 类型判断（大写）
export const typeOf = (obj) => {
  const objStr = Object.prototype.toString.call(obj)
  return objStr.replace('[object ', '').replace(']', '')
}

// 格式化数字
export function formatterNumber (value, pointNum = 1) {
  if (typeOf(value) === 'Number') {
    const valueStr = value.toFixed(pointNum)
    return parseFloat(valueStr)
  }
  return value
}



// WEBPACK FOOTER //
// ./src/utils/utils.js